import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppData } from '@shared/models/appdata.model';

export interface PortingWindowsResponse {
  withLogistics: PortingWindow[];
  withoutLogistics: PortingWindow[];
}

export interface PortingWindow {
  date: string;
  allowedPortingHoursStart: number;
  allowedPortingHoursEnd: number;
}

@Injectable({
  providedIn: 'root',
})
export class PortingService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = `${this.appData.apiUrl}/api/v1`;

  getPortingDates(): Observable<PortingWindowsResponse> {
    const url = `${this.apiUrl}/porting/all-porting-windows`;

    return this.http.get<PortingWindowsResponse>(url);
  }
}
